// enquire.js

$().ready(function() {
  /**
   *
   * @param {*} message
   * @param {*} header
   */
  function showModal(message, header) {
    $('#modal-1-txt').text(message);
    $('#modal-1-header').text(header);
    $('#modal-1').trigger( 'click' );

    var timeout = setTimeout(function() {
      $('#modal-1').trigger('click');
    }, 4000);

    $('#modal-1-close').click(function(event) {
      clearTimeout(timeout);
    });
  }

  $.validator.addMethod('custom_phone_number', function(value, element) {
    var re = /^[\d\s()+-]+$/;
    // eslint-disable-next-line no-invalid-this
    return this.optional(element) || re.test(value);
  }, function(params, element) {
    var id = $(element).attr('id');
    var label = $(element).closest('form').find( 'label[for=\'' +
      id + '\']' ).text();
    // eslint-disable-next-line max-len
    return label + ' may only contain: plus:+ min:- space:  and parenthesis:() or leave empty';
  });

  $.validator.setDefaults({

    invalidHandler: function(event, validator) {
      var errors = validator.numberOfInvalids();
      if (errors) {
        var message = errors == 1 ?
          'You missed 1 field. It has been highlighted' :
          'You missed ' + errors + ' fields. They have been highlighted';
        showModal(message, 'Error');
      }
    },
    submitHandler: function(form) {
      $.ajax({
        url: form.action,
        type: form.method,
        data: $(form).serialize(),
        complete: function(jqXHR, textStatus) {
          var responseText = jqXHR.responseText;
          var responseObj = JSON.parse(responseText);
          if (responseObj.status == 'success') {
            showModal('We will contact you as soon as possible.', 'Thank you');
            $('#js_enquire_reset').trigger( 'click' );
          } else {
            showModal('Please check your form.', 'Error');
          }
        },
        error: function(jqXHR, textStatus, errorThrown) {
          // eslint-disable-next-line max-len
          showModal('We did not receive your enquire, please contact us directly.', 'Error');
        },
      });
    },

    success: 'valid',
    focusInvalid: false,

  });

  $('#js_enquire_reset').click(function() {
    // eslint-disable-next-line no-invalid-this
    $(this.blur());
    $('.control-group').removeClass('error');
    validator.resetForm();
  });

  var validator = $('#js_enquire').validate({

    success: function(element) {
      var id = element.attr('id');
      id = id.replace('-error', '');
      $(element).closest('form')
        .find( 'label[for=\'' + id + '\']' ).parent().removeClass('error');
    },

    highlight: function(element, errorClass, validClass) {
      // element is a string
      var id = $(element).attr('id');
      $(element).closest('form')
        .find( 'label[for=\'' + id + '\']' ).parent().addClass('error');
    },

    unhighlight: function(element, errorClass, validClass) {
      var id = $(element).attr('id');
      $(element).closest('form')
        .find( 'label[for=\'' + id + '\']' ).parent().removeClass('error');
    },

    errorPlacement: function(error, element) {
      // var id = element.attr( 'id' );
      if (element.parent('span').length) {
        error.insertAfter(element.parent());
      } else {
        $(element).closest('form').find('label[for=\'' +
          element.attr( 'id' ) + '\']').next().append(error);
      }
    },

    errorElement: 'p',
    errorClass: 'tip',
    rules: {
      first_name: {
        required: true,
        minlength: 2,
      },
      last_name: {
        required: true,
        minlength: 2,
      },
      company_name: {
        required: false,
        minlength: 2,
      },
      email_address: {
        required: true,
        email: true,
      },
      telephone_number: {
        required: false,
        minlength: 8,
        custom_phone_number: true,
      },
      mobile_number: {
        required: false,
        minlength: 8,
        custom_phone_number: true,
      },
      address: {
        required: false,
        minlength: 2,
      },
      address_2: {
        required: false,
        minlength: 2,
      },
      city: {
        required: false,
        minlength: 2,
      },
      county: {
        required: false,
        minlength: 2,
      },
      post_code: {
        required: false,
        minlength: 2,
      },
      country: {
        required: false,
        minlength: 2,
      },
      property_size: {
        required: false,
        minlength: 2,
      },
      livestock_type: {
        required: false,
        minlength: 2,
      },
      soil_test_required: {
        required: false,
      },
      prefered_application: {
        required: false,
      },
      other_services_required: {
        required: false,
      },
      comments_or_special_requests: {
        required: false,
        minlength: 30,
      },
    },
    /* eslint-disable */
    messages: {
      first_name: {
        required: 'Please enter your First Name',
        minlength: 'Your First Name must consist of at least 2 characters',
      },
      last_name: {
        required: 'Please enter your Last Name',
        minlength: 'Your Last Name must consist of at least 2 characters',
      },
      company_name: {
        required: 'Please enter your Company Name or leave it empty',
        minlength: 'Your Company must consist of at least 2 characters or leave empty',
      },
      email_address: {
        required: 'Please enter your Email Address',
        email: 'Email Address must be valid',
      },
      telephone_number: {
        required: 'Please enter your Telephone Number or leave it empty',
        minlength: 'Your Telephone Number must consist of at least 8 characters or leave empty',
      },
      mobile_number: {
        required: 'Please enter your Mobile Number or leave it empty',
        minlength: 'Your Mobile Number must consist of at least 8 characters or leave empty',
      },
      address: {
        required: 'Please enter your Address or leave it empty',
        minlength: 'Your Adress must consist of at least 2 characters or leave empty',
      },
      address_2: {
        required: 'Please enter Address (line 2) or leave it empty',
        minlength: 'Address (line 2 ) must consist of at least 2 characters or leave empty',
      },
      city: {
        required: 'Please enter your City or leave it empty',
        minlength: 'Your City must consist of at least 2 characters or leave empty',
      },
      county: {
        required: 'Please enter your County or leave it empty',
        minlength: 'Your County must consist of at least 2 characters or leave empty',
      },
      post_code: {
        required: 'Please enter your Post Code or leave it empty',
        minlength: 'Your Post Code must consist of at least 2 characters or leave empty',
      },
      country: {
        required: 'Please enter your Country or leave it empty',
        minlength: 'Your Country must consist of at least 2 characters or leave empty',
      },
      property_size: {
        required: 'Please enter your Property Size or leave it empty',
        minlength: 'Your Property Size must consist of at least 2 characters or leave empty',
      },
      livestock_type: {
        required: 'Please enter your Livestock Type or leave it empty',
        minlength: 'Your Livestock Type must consist of at least 2 characters or leave empty',
      },
      soil_test_required: {
        required: 'Please select Soil Test Required or leave it empty',
      },
      prefered_application: {
        required: 'Preferred Application is optional or leave it empty',
      },
      other_services_required: {
        required: 'Other Services Required is optional or leave it empty',
      },
      comments_or_special_requests: {
        required: 'Please enter your Comments Or Special Requests or leave it empty',
        minlength: 'Please give a decent description of at least 30 characters or leave empty',
      },
    },
  });
});

/* eslint-enable */

//
// EOF
//
